import { action, observable, makeObservable, computed } from 'mobx';
import { Notify } from '$src/utils/notify';
import { controlCenterApi } from '$src/api/control-center-api';

export default class GuardStore {
  loading = false;
  guard = {};

  setLoading = (value) => {
    this.loading = value;
  };

  setGuard = (guard) => {
    this.guard = guard;
  };

  setGuardCreationPending = () => {
    this.guard.pending = true;
  };

  fetchGuard = async (userId, locationId) => {
    try {
      this.setLoading(true);
      const guardStatus = await controlCenterApi.fetchGuard(userId, locationId);

      this.setGuard(guardStatus);
    } catch (e) {
      Notify.error('There was an error getting guard', e);
    } finally {
      this.setLoading(false);
    }
  };

  createGuard = async (userId, locationId, guard) => {
    try {
      this.setLoading(true);
      await controlCenterApi.createGuard(userId, locationId, guard);

      this.setGuard(guard);
      this.setGuardCreationPending();
    } catch (e) {
      Notify.error('There was an error creating guard', e);
    } finally {
      this.setLoading(false);
    }
  };

  deleteGuard = async (userId, locationId) => {
    try {
      this.setLoading(true);
      await controlCenterApi.deleteGuard(userId, locationId);

      this.setGuard({});
    } catch (e) {
      Notify.error('There was an error removing guard', e);
    } finally {
      this.setLoading(false);
    }
  };

  get isGuardCreationPending() {
    return this.guard?.pending;
  }

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      loading: observable,
      guard: observable,
      setLoading: action,
      setGuard: action,
      setGuardCreationPending: action,
      fetchGuard: action,
      createGuard: action,
      deleteGuard: action,
      isGuardCreationPending: computed,
    });
  }
}
